import React from "react";
import {
  Rendertext,
  Renderradio,
  Rendercheckbox,
} from "./dynamic_renderComponent";

export default function render_detail(props) {
  let clonedynamic_state = props.data;
  return (
    <>
      {clonedynamic_state.text !== undefined &&
      clonedynamic_state.text.length > 0
        ? clonedynamic_state.text.map((value, index) => {
            return (
              <Rendertext
                key={index + 121}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.password !== undefined &&
      clonedynamic_state.password.length > 0
        ? clonedynamic_state.password.map((value, index) => {
            return (
              <Rendertext
                key={index + 551}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.radio !== undefined &&
      clonedynamic_state.radio.length > 0
        ? clonedynamic_state.radio.map((value, index) => {
            return (
              <Renderradio
                key={index + 7894}
                label={value.label}
                value={value.value}
              ></Renderradio>
            );
          })
        : null}

      {clonedynamic_state.checkbox !== undefined &&
      clonedynamic_state.checkbox.length > 0
        ? clonedynamic_state.checkbox.map((value, index) => {
            return (
              <Rendercheckbox
                key={index + 65235}
                label={value.label}
                value={value.value}
              ></Rendercheckbox>
            );
          })
        : null}

      {clonedynamic_state.date !== undefined &&
      clonedynamic_state.date.length > 0
        ? clonedynamic_state.date.map((value, index) => {
            return (
              <Rendertext
                key={index + 77884}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.datetime !== undefined &&
      clonedynamic_state.datetime.length > 0
        ? clonedynamic_state.datetime.map((value, index) => {
            return (
              <Rendertext
                key={index}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.email !== undefined &&
      clonedynamic_state.email.length > 0
        ? clonedynamic_state.email.map((value, index) => {
            return (
              <Rendertext
                key={index + 998874}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.month !== undefined &&
      clonedynamic_state.month.length > 0
        ? clonedynamic_state.month.map((value, index) => {
            return (
              <Rendertext
                key={index + 58584}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.number !== undefined &&
      clonedynamic_state.month.length > 0
        ? clonedynamic_state.number.map((value, index) => {
            return (
              <Rendertext
                key={index + 63214}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.range !== undefined &&
      clonedynamic_state.range.length > 0
        ? clonedynamic_state.range.map((value, index) => {
            return (
              <Rendertext
                key={index + 6974545}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.phone !== undefined &&
      clonedynamic_state.phone.length > 0
        ? clonedynamic_state.phone.map((value, index) => {
            return (
              <Rendertext
                key={index + 325252}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.time !== undefined &&
      clonedynamic_state.time.length > 0
        ? clonedynamic_state.time.map((value, index) => {
            return (
              <Rendertext
                key={index + 9857}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.url !== undefined && clonedynamic_state.url.length > 0
        ? clonedynamic_state.url.map((value, index) => {
            return (
              <Rendertext
                key={index + 3310}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.week !== undefined &&
      clonedynamic_state.week.length > 0
        ? clonedynamic_state.week.map((value, index) => {
            return (
              <Rendertext
                key={index + 1550}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.nomultiple !== undefined &&
      clonedynamic_state.nomultiple.length > 0
        ? clonedynamic_state.nomultiple.map((value, index) => {
            return (
              <Rendertext
                key={index + 1112}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.multiple !== undefined &&
      clonedynamic_state.multiple.length > 0
        ? clonedynamic_state.multiple.map((value, index) => {
            return (
              <Rendertext
                key={index + 65308}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.callapi !== undefined &&
      clonedynamic_state.callapi.length > 0
        ? clonedynamic_state.callapi.map((value, index) => {
            return (
              <Rendertext
                key={index + 65557}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.textarea !== undefined &&
      clonedynamic_state.textarea.length > 0
        ? clonedynamic_state.textarea.map((value, index) => {
            return (
              <Rendertext
                key={index + 457410}
                label={value.label}
                value={value.value}
              ></Rendertext>
            );
          })
        : null}

      {clonedynamic_state.table !== undefined
        ? console.log(JSON.parse(clonedynamic_state.table))
        : null}
    </>
  );
}
